export default __webpack_public_path__ + "static/media/notification-refresh.bd510dc1.svg";